import React, { useState } from 'react'
import TextField from '@mui/material/TextField';
import config from '../../config';
import { Button, Grid } from '@mui/material';
import { connect } from 'react-redux';
import { setJeton } from '../../redux/actions';
import AuthentificationO365 from './AuthentificationO365';

function Authentification({ jeton, setJeton }) {

    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");

    const connecter = () => {
        if (user !== "" && password !== "") {
            const parametre = encodeURI(JSON.stringify({
                bdd: 'administration',
                email: user,
                motdepasse: password,
            }));
            fetch(config.serveur + "authUtilisateurs/" + parametre)
                .then(result => result.json())
                .then((result) => {
                    if (result.jeton) {
                        setJeton(result.jeton);
                    }
                })
        }
    }


    return typeof jeton === "undefined" || jeton === "" ?
        <>
            <div className='separation_fenetre'></div>
            <div>
                <div className="contenufenetre">
                    <div className="classeentete">Authentification</div>
                    <div style={{ margin: 8, textAlign: "center" }}>
                        <Grid container spacing={1} >
                            <Grid item xs={12} >
                                <TextField id="authuser" size="small" label="Nom connexion" variant="outlined" value={user} onChange={(val) => setUser(val.target.value)} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField id="authpassword" type={"password"} size="small" label="Mot de passe" variant="outlined" value={password} onChange={(val) => setPassword(val.target.value)} />
                            </Grid>
                        </Grid>
                    </div>
                    <div className="classefindepage">
                        <Button variant="contained" onClick={() => connecter()}>Connecter</Button>
                    </div>
                    <div className="classefindepage">
                        <AuthentificationO365 />
                    </div>

                </div>
            </div>
        </>
        :
        null
}


function mapStateToProps(state) {
    return {
        jeton: state.jeton,
    }
}

export default connect(mapStateToProps, { setJeton })(Authentification);